// BlogEditPage.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TinyMCEEditor from "../../components/TinyMCEEditor";
import { uploadData, remove } from "aws-amplify/storage";
import { Buffer } from "buffer";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { v4 as uuidv4 } from "uuid";

export const BlogIndividualEdit = () => {
  const { blogId } = useParams();
  const navigator = useNavigate();
  const [richTextContent, setRichTextContent] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [avatarSrc, setAvatarSrc] = React.useState();
  let imgId = "";
  let richTextId = "";
  const [blog, setBlog] = useState({
    title: "",
    content: "",
    richTextContent: "",
    tags: "",
    like: 0,
    read_time: 0,
    items: [],
    user_id: {
      _id: "",
      name: "",
      email: "",
    },
    time: "",
  });
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setAvatarSrc(URL.createObjectURL(file));
  };
  const generateUniqueKey = () => {
    const uniqueKey = uuidv4();
    return uniqueKey;
  };

  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  useEffect(() => {
    const getBlog = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/indi/${blogId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        setBlog(data.blogs);
        // console.log(data.blogs.items[0].s3Key);
      } catch (error) {
        console.log(error);
      }
    };

    getBlog();
  }, [blogId]);

  // Inside useEffect in BlogIndividualEdit.js
  useEffect(() => {
    if (blog?.richTextContent) {
      fetch(blog.richTextContent)
        .then((response) => response.text())
        .then((content) => setRichTextContent(content))
        .catch((error) =>
          console.error("Error fetching rich text content:", error)
        );
    } else {
      setRichTextContent(""); // Set an initial empty string
    }
  }, [blog?.richTextContent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBlog((prevBlog) => ({
      ...prevBlog,
      [name]: value,
    }));
  };
  const extractBlogIdFromS3Link = (s3Link) => {
    const regex = /\/richTextContent\/([^.]+)\.txt/;
    const match = s3Link.match(regex);
    return match ? match[1] : null;
  };

  const uploadImageToS3 = async () => {
    try {
      if (blog.items[0] && blog.items[0].s3Key) {
        await remove(blog.items[0].s3Key);
      }
      imgId = generateUniqueKey();
      const imageKey = `images/${imgId}_${imageFile.name}`;

      const res = await uploadData({
        key: imageKey,
        data: imageFile,
        options: {
          contentType: imageFile.type,
          acl: "public-read",
        },
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if an image file is selected
    let newData = {};
    if (imageFile) {
      await uploadImageToS3();
      newData = {
        ...blog,
        items: [
          {
            s3Key: `public/images/${imgId}_${imageFile.name}`,
            bucket: process.env.REACT_APP_AWS_BUCKET,
            mime: imageFile.type,
            region: process.env.REACT_APP_AWS_REGION,
            dateCreated: new Date(),
          },
        ],
      };
    } else {
      newData = {
        ...blog,
      };
    }

    try {
      // Upload rich text content to S3
      // console.log(richTextContent);
      {
        richTextId = extractBlogIdFromS3Link(blog?.richTextContent);
        const richTextContentKey = `richTextContent/${richTextId}.txt`;
        const res = await uploadData({
          key: richTextContentKey,
          data: richTextContent,
          options: {
            contentType: "text/plain",
            acl: "public-read",
          },
        });
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/edit/${blogId}`,
        {
          ...newData,
          richTextContent: `https://${process.env.REACT_APP_AWS_BUCKET}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/public/richTextContent/${richTextId}.txt`,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Redirect to the individual blog page after editing
      navigator(`/home`);
    } catch (error) {
      console.log(error);
    }
  };

  if (!blog) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4">Edit Blog</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          value={blog.title}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Content"
          name="content"
          multiline
          rows={4}
          value={blog.content}
          onChange={handleChange}
        />
        {/* <TextField
          fullWidth
          margin="normal"
          label="Rich Text Content"
          name="richTextContent"
          value={richTextContent}
          onChange={handleChange}
        /> */}
        <TinyMCEEditor
          value={richTextContent}
          onChange={(content) => setRichTextContent(content)}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Tags"
          name="tags"
          value={blog.tags}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Read Time (minutes)"
          name="read_time"
          type="number"
          value={blog.read_time}
          onChange={handleChange}
        />
        <FormControl fullWidth margin="normal">
          {/* <InputLabel htmlFor="image">Image</InputLabel> */}
          <Input
            type="file"
            accept="image/*"
            id="image"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
          <label htmlFor="image">
            <Button
              variant="outlined"
              component="span"
              startIcon={<CloudUploadIcon />}
            >
              Upload Image
            </Button>
          </label>
          {blog.items.map((item) => (
            <img
              key={item._id}
              src={`https://${item.bucket}.s3.${item.region}.amazonaws.com/${item.s3Key}`}
              alt="Blog Images"
              style={{ maxWidth: "30%", margin: "10px 0" }}
            />
          ))}
          <img
            src={avatarSrc}
            style={{ width: "12vw", margin: "1.5rem 0px" }}
          />
        </FormControl>
        {/* Add more form fields based on your blog schema */}
        <Button type="submit" variant="contained" color="primary">
          Save Changes
        </Button>
      </form>
    </div>
  );
};
